declare namespace $ {

	type $mol_string_button__value_shm_hitalama_components_drafts_editor_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_drafts_editor['name'] >
		,
		ReturnType< $mol_string_button['value'] >
	>
	type $mol_string_button__hint_shm_hitalama_components_drafts_editor_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string_button['hint'] >
	>
	type $shm_confirm_delete__title_shm_hitalama_components_drafts_editor_3 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_confirm_delete['title'] >
	>
	type $shm_confirm_delete__confirmed_shm_hitalama_components_drafts_editor_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_drafts_editor['remove'] >
		,
		ReturnType< $shm_confirm_delete['confirmed'] >
	>
	type $mol_button_minor__hint_shm_hitalama_components_drafts_editor_5 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_shm_hitalama_components_drafts_editor_6 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_drafts_editor['close'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_shm_hitalama_components_drafts_editor_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $shm_hitalama_text_editor__value_shm_hitalama_components_drafts_editor_8 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_drafts_editor['text'] >
		,
		ReturnType< $shm_hitalama_text_editor['value'] >
	>
	type $shm_hitalama_text_editor__owner_shm_hitalama_components_drafts_editor_9 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_drafts_editor['image_owner'] >
		,
		ReturnType< $shm_hitalama_text_editor['owner'] >
	>
	export class $shm_hitalama_components_drafts_editor extends $mol_page {
		name( next?: string ): string
		Name( ): $mol_string_button
		focus_auto( ): any
		remove( next?: any ): any
		Delete( ): $shm_confirm_delete
		close( next?: any ): any
		Close_icon( ): $mol_icon_close
		Close( ): $mol_button_minor
		text( next?: string ): string
		image_owner( ): $giper_baza_entity
		Text( ): $shm_hitalama_text_editor
		model( ): $shm_hitalama_components_drafts_model
		selected( ): string
		editing( next?: boolean ): boolean
		removed( next?: any ): any
		focus_end( id: any): any
		title( ): string
		title_content( ): readonly(any)[]
		minimal_width( ): number
		auto( ): readonly(any)[]
		tools( ): readonly(any)[]
		body( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=editor.view.tree.d.ts.map